/**
 * @file Default number format options
 */

/**
 * @typedef {Object} NumberFormatOptions
 * @property {string} style
 * @property {number} [minimumFractionDigits]
 * @property {number} [maximumFractionDigits]
 */

/**
 * @enum {NumberFormatOptions}
 * @readonly
 */
const NUMBER_FORMATS = {
    default: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    },
    integer: {
        style: 'decimal',
        maximumFractionDigits: 0
    },
    integerOrBigUnit: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
    },
    smallUnit: {
        style: 'decimal',
        maximumFractionDigits: 0
    },
    bigUnit: {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }
}

export default NUMBER_FORMATS
